import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dynmacicsqlgridmodal',
  templateUrl: './dynmacicsqlgridmodal.component.html',
  styleUrls: ['./dynmacicsqlgridmodal.component.css']
})
export class DynmacicsqlgridmodalComponent {
  // constructor(
  //   public dialogRef: MatDialogRef<StatusDialogComponent>,
  //   @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
  // ) {}
}
